<template>
  <div class="m-chat-editor" @click="hideRobotList">
    <chat-emoji
      v-bind:type="type"
      v-bind:scene="scene"
      v-bind:to="to"
      v-show="isEmojiShown"
      v-on:add-emoji="addEmoji"
      v-on:hide-emoji="hideEmoji"
      :orderTreatId="orderTreatId"
    ></chat-emoji>
    <div v-show="isRobotListShown" class="m-chat-emoji m-chat-robot">
      <div
        v-for="robot in robotslist"
        :title="robot.nick"
        :key="robot.account"
        @click.native="chooseRobot(robot)"
      >
        <img
          class="icon u-circle"
          slot="icon"
          width="20"
          height="20"
          :src="robot.avatar"
        />
      </div>
    </div>
    <div
      class="m-chat-editor-main"
      v-if="
        $route.query.status == 10005 || $route.query.status == 10008
          ? false
          : true
      "
      :class="{ robot: isRobot }"
    >
      <span class="mic">
        <div class="reacd-time" v-if="!isReacd">{{ reactTime }}</div>
        <img
          v-if="isReacd"
          src="../../assets/images/mic.png"
          alt
          @click="reacdHandle('start')"
        />
        <img
          v-else
          src="../../assets/images/micr.png"
          alt
          @click="reacdHandle('stop')"
        />
      </span>
      <span class="u-editor-input">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 2 }"
          placeholder="请输入内容"
          v-model="msgToSent"
          @focus="onInputFocus"
          @keyup.enter.native="sendTextMsg()"
          maxlength="500"
        ></el-input>
      </span>
      <span class="u-editor-icons"> </span>
    </div>
    <div class="btn_warp">
      <el-button
        type="primary"
        plain
        size="small"
        v-if="!isRobot"
        class="u-editor-icon btn_mt"
        @click.stop="showEmoji"
        >添加表情</el-button
      >
      <el-button type="primary" size="small" plain class="u-editor-icon btn_mt"
        >传输文件
        <input
          type="file"
          ref="fileToSent"
          accept="image/*"
          @change="sendFileMsg"
        />
      </el-button>
      <!-- 常用语 -->
      <el-popover placement="top" width="400" trigger="click">
        <div
          class="common-warp"
          v-for="(item, index) in CommonWordsList"
          :key="index"
        >
          <div class="common-word">
            <div
              class="common-word__top-title"
              @click="sendCommon(item.phrase)"
            >
              {{ index + 1 }}.{{ item.phrase }}
            </div>
            <div>
              <i
                @click="handleEdit(item)"
                class="el-icon-edit icon_fontSize"
              ></i>
              <i
                @click="handelDelete(item.phraseId)"
                class="el-icon-delete icon_fontSize"
              ></i>
            </div>
          </div>
          <el-divider></el-divider>
        </div>
        <div class="common-footer">
          <div class="common-footer__warp" @click="handelAdd">
            <div><i class="el-icon-edit-outline"></i></div>
            <div>添加</div>
          </div>
          <!-- <div class="common-footer__warp">
            <div><i class="el-icon-setting"></i></div>
            <div>管理</div>
          </div> -->
        </div>
        <el-button
          class="btn_mt"
          type="primary"
          style="margin:0 10px 0 5px"
          plain
          slot="reference"
          size="small"
          >常用语</el-button
        >
      </el-popover>
      <!-- **** -->
      <el-button type="primary" class="btn_mt" size="small" @click="startLive"
        >视频聊天</el-button
      >
      <el-button class="btn_mt" type="primary" @click="sendTextMsg"
        >发 送</el-button
      >
    </div>
    <call-popup
      :visible.sync="isShowCallPopup"
      v-if="isShowCallPopup"
      :target="sickInfo"
      @on-inter-room="onEnterRoom"
    />
    <AdverseEvent
      :centerDialogVisible="centerDialogVisible"
      :treatId="$route.query.treatId"
    />
    <!-- 添加常用语 -->
    <el-dialog
      :title="commonTitle"
      :visible.sync="commontDialogVisible"
      width="30%"
      center
    >
      <el-input
        type="textarea"
        :autosize="{ minRows: 2, maxRows: 4 }"
        placeholder="请输入内容"
        v-model="commonWords"
        maxlength="50"
        show-word-limit
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="commontDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handelSubmitCommonWord"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ChatEmoji from "./ChatEmoji";
import util from "@/utils";
import cookie from "@/utils/cookie";
import config from "@/config/config";
import callPopup from "./components/callPopup";
import AdverseEvent from "@/components/common/AdverseEvent";

import { createRoom, webCall, overDiagnose, imMsgRemind } from "@/api/doctor";
import { getPatientByAccid, readImRecord } from "@/api/index";
import {
  getCommonWordsList,
  addCommonWords,
  deleteCommonWords,
  updateCommonWords,
} from "@/api";

export default {
  components: {
    ChatEmoji,
    callPopup,
    AdverseEvent,
  },
  updated() {
    window.document.body.addEventListener("click", () => {
      this.isEmojiShown = false;
    });
  },
  props: {
    type: String,
    scene: String,
    to: String,
    isRobot: {
      type: Boolean,
      default() {
        return false;
      },
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    invalidHint: {
      type: String,
      default: "您无权限发送消息",
    },
    advancedTeam: {
      type: Boolean,
      default: false,
    },
    orderTreatId: {
      type: Number,
      // default: 0
    },
    orderNum: String,
    sickInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    uid: Number,
  },
  watch: {
    continueRobotAccid(curVal, oldVal) {
      if (curVal && this.robotInfos[curVal]) {
        this.msgToSent = `@${this.robotInfos[curVal].nick} `;
      }
      // 重置
      this.$store.dispatch("continueRobotMsg", "");
    },
    msgToSent(curVal, oldVal) {
      if (this.isRobot) {
        return;
      }
      let indexAt = this.msgToSent.indexOf("@");
      if (indexAt >= 0 && indexAt === this.msgToSent.length - 1) {
        if (this.robotslist && this.robotslist.length > 0) {
          this.isRobotListShown = true;
        }
      } else if (this.isRobotListShown === true) {
        this.isRobotListShown = false;
      }
    },
  },
  data() {
    const data = {
      // showCommonWrods: true,
      // showCommonWrodsInput: false,
      commonId: "",
      phraseId: "",
      commonTitle: "添加常用语",
      CommonWordsList: [],
      commonWords: "",
      commontDialogVisible: false,
      tableData: [
        {
          expressions: "123123",
        },
        {
          expressions: "321321",
        },
      ],
      show: true,
      count: "",
      timeNum: null,
      isShowInput: true,
      centerDialogVisible: { value: false },
      dialogVisible: false,
      isEmojiShown: false,
      isRobotListShown: false,
      msgToSent: "",
      icon1: `${config.resourceUrl}/im/chat-editor-1.png`,
      icon2: `${config.resourceUrl}/im/chat-editor-2.png`,
      icon3: `${config.resourceUrl}/im/chat-editor-3.png`,
      icon4: `https://yx-web-nosdn.netease.im/quickhtml%2Fassets%2Fyunxin%2Fdefault%2Fchat-editor-keyboard.png`,
      icon5: `https://yx-web-nosdn.netease.im/quickhtml%2Fassets%2Fyunxin%2Fdefault%2Fchat-editor-record.png`,
      sendTxt: true,
      recording: false,
      recordDisable: false,
      toRecordCount: 0,
      recordTime: 0,
      $recordTime: null,
      recordTimeout: "",
      recorder: null,
      audioContext: null,
      isReacd: true,
      reactTime: "00:00",
      chunks: [],
      stream: {},
      timer: {},
      rcdTime: 0,
      isLive: false,
      isShowCallPopup: false,
      patientId: '',
    };

    try {
      data.audioContext = new window.AudioContext();
    } catch (e) {
      data.recordDisable = true;
    }
    return data;
  },
  computed: {
    continueRobotAccid() {
      return this.$store.state.continueRobotAccid;
    },
    robotslist() {
      return this.$store.state.robotslist;
    },
    robotInfos() {
      return this.$store.state.robotInfos;
    },
    robotInfosByNick() {
      return this.$store.state.robotInfosByNick;
    },
    supportTouch() {
      return "ontouchend" in document &&
        "ontouchstart" in document &&
        "ontouchmove" in document
        ? true
        : false;
    },

    isHostHttps() {
      //判断是否是https协议,用于展示录音图标
      if (location.protocol === "http:") {
        return false;
      } else {
        return true;
      }
    },
  },
  created() {
    this.getCommonWordsList();
    this.getPatientByAccid()
  },
  methods: {
    // 根据accid获取用户id
    async getPatientByAccid() {
      const params = {
        accId: this.to,
      };
      const { code, data } = await getPatientByAccid(params);
      this.patientId = data.id
    },
    // 发送常用语
    sendCommon(item) {
      this.msgToSent = item;
      // this.sendTextMsg();
    },
    // 编辑常用语
    handleEdit(val) {
      this.commonWords = val.phrase;
      this.commonId = val.phraseId;
      this.commontDialogVisible = true;
      this.commonTitle = "修改常用语";
    },
    // 删除常用语
    handelDelete(val) {
      this.$confirm("此操作将永久删除该常用语, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(async () => {
        const params = {
          phraseId: val,
        };
        const { code } = await deleteCommonWords(params);
        if (code == 1) {
          this.$message.success("删除成功");
          this.getCommonWordsList();
        }
      });
    },
    // 确定添加医生常用语
    async handelSubmitCommonWord() {
      if (!this.commonWords) return this.$message.error("请填写常用语内容");
      if (this.commonTitle == "添加常用语") {
        const { code } = await addCommonWords({
          phrase: this.commonWords,
        });
        if (code == 1) {
          this.getCommonWordsList();
          this.commontDialogVisible = false;
        }
      } else {
        const { code } = await updateCommonWords({
          phrase: this.commonWords,
          phraseId: this.commonId,
        });
        if (code == 1) {
          this.getCommonWordsList();
          this.commontDialogVisible = false;
        }
      }
    },
    // 添加医生常用语
    handelAdd() {
      this.commontDialogVisible = true;
      this.commonWords = "";
      this.commonId = "";
      this.commonTitle = "添加常用语";
    },
    // 获取医生常用语
    async getCommonWordsList() {
      const { code, data } = await getCommonWordsList();
      if (code == 1) {
        this.CommonWordsList = data;
      }
    },
    callphone() {
      const TIME_COUNT = 60;
      if (!this.timeNum) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timeNum = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timeNum);
            this.timeNum = null;
          }
        }, 1000);
      }
    },
    // 打电话
    async subWebCall() {
      const query = {
        orderNo: this.$route.query.treatId,
      };
      const res = await webCall(query);
      if (res.code == 1) {
        this.dialogVisible = false;
        this.callphone();
        if (res.data.succeed && res.data.message == "4") {
          this.$message.success("已接听");
        }
        if (res.data.succeed && res.data.message == "0") {
          this.$message.warning("线路繁忙/异常");
        }
        if (res.data.succeed && res.data.message == "8") {
          this.$message.warning("线路繁忙/异常");
        }
        if (res.data.succeed && res.data.message == "3") {
          this.$message.success("被叫拒绝/振铃未接/占线/关机/空号");
        }
        if (res.data.succeed && res.data.message == "5") {
          this.$message.success("余额不足，请先检查账户资费");
        }
      }
    },
    // 举报患者
    reportPatient() {
      this.centerDialogVisible.value = true;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    // 结束诊断
    overDiagnose() {
      // this.$store.dispatch("sendMsg", {
      //   type: "custom",
      //   scene: this.scene,
      //   to: this.to,
      //   pushContent: "[结束诊断]",
      //   content: {
      //     type: 5,
      //     data: {
      //       value: "结束诊断",
      //     },
      //   },
      // });
      this.$confirm("此操作将结束会话并退出该页面, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const params = {
          orderNo: this.$route.query.treatId,
        };
        const res = await overDiagnose(params);
        if (res.code == 1) {
          this.$store.dispatch("sendMsg", {
            type: "custom",
            scene: this.scene,
            to: this.to,
            pushContent: "[结束诊断]",
            content: {
              type: 5,
              data: {
                value: "结束诊断",
              },
            },
          });
          this.$router.go(-1);
        }
      });
    },
    //开始视频
    // startLive() {
    //   this.isShowCallPopup = true;
    // },
    async startLive(type) {
      const params = {
        orderNo: this.$route.query.treatId,
        // senderAccId: this.to,
        senderAccId: cookie.readCookie("uid"),
        recipientAccid: this.to,
      };
      const res = await createRoom(params);
      // this.isShowCallPopup = false;
      if (res.code == 1) {
        this.$router.push({
          path: "/netcall",
          query: {
            // channelName: this.sickInfo.orderNumber,
            channelName: res.data,
            requestId: this.uid,
            uid: this.uid,
            // uid: Math.ceil(Math.random() * 1e5),
            account: this.to,
            treatId: this.$route.query.treatId,
            target: this.$route.query.patientName || "",
            // device: type.length > 0 ? type.toString() : "",
            device: "1,2",
          },
        });
      }
    },
    restBtn() {
      this.isLive = false;
    },
    joinVideoRoom(channelName) {
      this.$store.dispatch("joinRoom", channelName).then((res) => {
        this.isLive = true;
        this.$emit("on-update-local-div", true);
      });
    },
    //关闭频道
    closeChannel() {
      const { channelId } = this.$store.state;
      this.$store.dispatch("closeSignaLing", channelId).then((res) => {
        console.log("频道，关闭");
      });
    },
    async sendTextMsg() {
      if (this.invalid) {
        return;
      }
      if (/^\s*$/.test(this.msgToSent)) {
        this.$message({
          type: "error",
          message: "请不要发送空消息",
        });
        return;
      } else if (this.msgToSent.length > 800) {
        this.$message({
          type: "error",
          message: "请不要超过800个字",
        });
        return;
      }
      this.msgToSent = this.msgToSent.trim();
      if (this.type === "session") {
        // 如果是机器人
        if (this.isRobot) {
          this.$store.dispatch("sendRobotMsg", {
            type: "text",
            scene: this.scene,
            to: this.to,
            robotAccid: this.to,
            // 机器人后台消息
            content: this.msgToSent,
            // 显示的文本消息
            body: this.msgToSent,
          });
        } else {
          let robotAccid = "";
          let robotText = "";

          let atUsers = this.msgToSent.match(/@[^\s@$]+/g);
          if (atUsers) {
            for (let i = 0; i < atUsers.length; i++) {
              let item = atUsers[i].replace("@", "");
              if (this.robotInfosByNick[item]) {
                robotAccid = this.robotInfosByNick[item].account;
                robotText = (this.msgToSent + "")
                  .replace(atUsers[i], "")
                  .trim();
                break;
              }
            }
          }
          if (robotAccid) {
            if (robotText) {
              this.$store.dispatch("sendRobotMsg", {
                type: "text",
                scene: this.scene,
                to: this.to,
                robotAccid,
                // 机器人后台消息
                content: robotText,
                // 显示的文本消息
                body: this.msgToSent,
              });
            } else {
              this.$store.dispatch("sendRobotMsg", {
                type: "welcome",
                scene: this.scene,
                to: this.to,
                robotAccid,
                // 显示的文本消息
                body: this.msgToSent,
              });
            }
          } else {
            this.$store.dispatch("sendMsg", {
              type: "text",
              scene: this.scene,
              to: this.to,
              text: this.msgToSent,
              orderTreatId: this.orderTreatId,
            });
          }
        }
      } else if (this.type === "chatroom") {
        let robotAccid = "";
        let robotText = "";

        let atUsers = this.msgToSent.match(/@[^\s@$]+/g);
        if (atUsers) {
          for (let i = 0; i < atUsers.length; i++) {
            let item = atUsers[i].replace("@", "");
            if (this.robotInfosByNick[item]) {
              robotAccid = this.robotInfosByNick[item].account;
              robotText = (this.msgToSent + "").replace(atUsers[i], "").trim();
              break;
            }
          }
        }
        if (robotAccid) {
          if (robotText) {
            this.$store.dispatch("sendChatroomRobotMsg", {
              type: "text",
              robotAccid,
              // 机器人后台消息
              content: robotText,
              // 显示的文本消息
              body: this.msgToSent,
            });
          } else {
            this.$store.dispatch("sendChatroomRobotMsg", {
              type: "welcome",
              robotAccid,
              // 显示的文本消息
              body: this.msgToSent,
            });
          }
        } else {
          this.$store.dispatch("sendChatroomMsg", {
            type: "text",
            text: this.msgToSent,
          });
        }
      }
      const params = new FormData();
      params.append("recipient", this.patientId);
      params.append("body", this.msgToSent);
      params.append("orderNo", this.$route.query.treatId || "");
      params.append("msgType", "11501");
      await readImRecord(params);
      this.msgToSent = "";
    },
    sendPlayMsg() {
      if (this.invalid) {
        this.$toast(this.invalidHint);
        return;
      }
      // 发送猜拳消息
      if (this.type === "session") {
        this.$store.dispatch("sendMsg", {
          type: "custom",
          scene: this.scene,
          to: this.to,
          pushContent: "[猜拳]",
          content: {
            type: 1,
            data: {
              value: Math.ceil(Math.random() * 3),
            },
          },
        });
      } else if (this.type === "chatroom") {
        this.$store.dispatch("sendChatroomMsg", {
          type: "custom",
          pushContent: "[猜拳]",
          content: {
            type: 1,
            data: {
              value: Math.ceil(Math.random() * 3),
            },
          },
        });
      }
    },
    async sendFileMsg() {
      if (this.invalid) {
        this.$toast(this.invalidHint);
        return;
      }
      let ipt = this.$refs.fileToSent;
      if (ipt.value) {
        if (this.type === "session") {
          this.$store.dispatch("sendFileMsg", {
            scene: this.scene,
            to: this.to,
            fileInput: ipt,
            orderTreatId: this.orderTreatId,
            ext: "mp3",
          });
        } else if (this.type === "chatroom") {
          this.$store.dispatch("sendChatroomFileMsg", {
            fileInput: ipt,
          });
        }
      }
      const params = new FormData();
      params.append("recipient", this.patientId);
      params.append("orderNo", this.$route.query.treatId || "");
      params.append("msgType", "11502");
      params.append("file", e.target.files[0]);
      await readImRecord(params);
      this.msgToSent = "";
    },
    showEmoji() {
      this.isEmojiShown = !this.isEmojiShown;
    },
    hideEmoji() {
      this.isEmojiShown = false;
    },
    addEmoji(emojiName) {
      this.msgToSent += emojiName;
      this.hideEmoji();
    },
    chooseRobot(robot) {
      if (robot && robot.account) {
        let len = this.msgToSent.length;
        if (len === 0 || this.msgToSent[len - 1] !== "@") {
          this.msgToSent += "@" + robot.nick + " ";
        }
        {
          this.msgToSent += robot.nick + " ";
        }
      }
    },
    hideRobotList() {
      this.isRobotListShown = false;
    },
    onInputFocus(e) {
      setTimeout(() => {
        // todo fixme 解决iOS输入框被遮挡问题，但会存在空白缝隙
        // e.target.scrollIntoView();
      }, 200);
    },
    turnToMsgReceipt() {
      if (this.invalid) {
        this.$toast(this.invalidHint);
        return;
      }
      location = `#/teamSendMsgReceipt/${this.to}`;
    },
    swicthMsgType() {
      this.sendTxt = !this.sendTxt;
    },
    videoCall() {
      const href = "https://huawan.zoomus.cn/j/15169672808";
      window.open(href, "_blank");
      // this.$message("正在维护。。。。。。");
    },
    //录制 yes or no
    async reacdHandle(type) {
      if (type == "start") {
        // if (window.stopPlayAudio) {
        //   window.stopPlayAudio();
        // }
        // if (location.protocol === "http:") {
        //   this.$message("请使用https协议");
        //   return;
        // }
        // if (
        //   this.recordDisable ||
        //   !this.audioContext ||
        //   !window.AudioContext ||
        //   !navigator.mediaDevices ||
        //   !navigator.mediaDevices.getUserMedia
        // ) {
        //   this.$message("当前浏览器不支持录音");
        //   return;
        // } else {
        this.isReacd = false;
        this.chunks = [];
        this.startReacd();
        // this.toRecord();
        this.reactTimeHandle();
        // }
      } else if (type == "stop") {
        this.isReacd = true;
        this.stopReacd();
        // this.sendRecordMsg();
        // this.reactTimeHandle(type);
      }
    },
    startReacd() {
      navigator.mediaDevices
        .getUserMedia({
          audio: true,
        })
        .then((stream) => {
          this.recorder = new window.MediaRecorder(stream);
          this.stream = stream;
          this.bindEvents();
          this.recorder.start();
        });
    },
    stopReacd() {
      clearInterval(this.timer);
      this.reactTime = "00:00";
      if (this.recorder) {
        this.recorder.stop();
        this.stream.getTracks().forEach((track) => track.stop());
      } else {
        return;
      }
    },
    bindEvents() {
      this.recorder.ondataavailable = this.getRecordingData;
      this.recorder.onstop = this.saveRecordingData;
    },
    getRecordingData(e) {
      this.chunks.push(e.data);
    },
    saveRecordingData() {
      let blob = new Blob(this.chunks, { type: "audio/wav" });
      setTimeout(this.sendVideoMsg(blob), 500);
    },
    reactTimeHandle() {
      var time = 0;
      // this.reactTime
      this.timer = setInterval(() => {
        time++;
        this.rcdTime = time;
        if (time >= 10) {
          this.reactTime = "00:" + time;
        }
        if (time >= 60) {
          this.reactTime =
            (time / 60).toString().split(".")[0] > 10
              ? (time / 60).toString().split(".")[0] +
                ":" +
                (time % 60 > 10 ? time % 60 : "0" + (time % 60))
              : "0" +
                (time / 60).toString().split(".")[0] +
                ":" +
                (time % 60 >= 10 ? time % 60 : "0" + (time % 60));
        }
        if (time < 10) {
          this.reactTime = "00:0" + time;
        }
      }, 1000);
    },
    async sendVideoMsg(blob) {
      if (this.reactTime < 2) {
        this.$message("语音消息最短2s");
        return;
      }
      this.$store.dispatch("sendMsgByPreview", {
        scene: this.scene,
        to: this.to,
        type: "audio",
        blob: blob,
        dur: this.rcdTime,
        orderTreatId: this.orderTreatId || "",
        ext: "mp3",
      });
      const params = new FormData();
      params.append("recipient", this.patientId);
      params.append("orderNo", this.$route.query.treatId || "");
      params.append("msgType", "11503");
      params.append("file", blob);
      await readImRecord(params);
    },
    toRecord() {
      var self = this;
      self.toRecordCount++;
      if (window.stopPlayAudio) {
        window.stopPlayAudio();
      }
      if (location.protocol === "http:") {
        this.$message("请使用https协议");
        return;
      }
      if (self.recording) {
        return;
      }
      if (self.toRecordCount > 1 && !self.recorder) {
        self.recordDisable = true;
      }
      if (
        self.recordDisable ||
        !self.audioContext ||
        !window.AudioContext ||
        !navigator.mediaDevices ||
        !navigator.mediaDevices.getUserMedia
      ) {
        this.$message("当前浏览器不支持录音");
        return;
      }
      if (self.recorder) {
        self.recorder.record();
        self.resumeAudioContext();
      } else {
        function failed() {
          self.recordDisable = true;
          this.$message("当前浏览器不支持录音");
        }
        try {
          var value = navigator.mediaDevices
            .getUserMedia({
              audio: true,
            })
            .then((stream) => {
              var input;
              try {
                input = self.audioContext.createMediaStreamSource(stream);
                self.recorder = new Recorder(input);
                self.recorder.record();
                self.resumeAudioContext();
                if (!self.recorder) {
                  failed();
                }
              } catch (e) {
                failed();
              }
            })
            .catch((err) => {
              // self.$toast("没有权限获取麦克风");
              this.$message("当前浏览器不支持录音");
              self.recordDisable = true;
              console.log(
                "No live audio input: " + err,
                err.name + ": " + err.message
              );
            });
        } catch (e) {
          failed();
        }
      }
    },
    runRecorderTime() {
      if (this.recorder) {
        this.recording = true;
        this.recordTime = 0;
        setTimeout(() => {
          this.$recordTime = document.getElementById("recordTime");
        }, 800);
        this.recordTimeout = setTimeout(
          this.runRecordDuration.bind(this),
          1000
        );
      }
    },
    resumeAudioContext() {
      if (this.audioContext && ~this.audioContext.state.indexOf("suspend")) {
        this.audioContext.resume().then(() => {
          console.log("audioContext suspend state resume");
          this.recorder.record();
          this.runRecorderTime();
        });
      } else {
        this.runRecorderTime();
      }
    },
    runRecordDuration() {
      this.recordTimeout = setTimeout(this.runRecordDuration.bind(this), 1000);
      this.recordTime++;
      if (this.recordTime >= 60) {
        clearTimeout(this.recordTimeout);
        this.sendRecord();
      }
      this.$recordTime.innerText =
        "00:" + (this.recordTime > 9 ? this.recordTime : "0" + this.recordTime);
    },
    siwtchRecord() {
      if (this.recording) {
        this.sendRecordMsg();
      } else {
        this.toRecord();
      }
    },
    cancelRecord() {
      if (this.recording) {
        this.recording = false;
        clearTimeout(this.recordTimeout);
        if (this.$recordTime) {
          this.$recordTime.innerText = "00:00";
        }
        this.recorder.stop();
        this.recorder.clear();
      }
    },
    sendRecordMsg() {
      setTimeout(this.sendRecord, 500);
    },
    sendRecord() {
      if (this.recording) {
        clearTimeout(this.recordTimeout);
        if (this.recordTime < 2) {
          // this.$toast("语音消息最短2s");
          this.$message("语音消息最短2s");
          this.cancelRecord();
          return;
        }
        this.recording = false;
        this.$recordTime.innerText = "00:00";
        this.recorder.stop();
        this.recorder.exportWAV((blob) => {
          this.$store.dispatch("showLoading");
          this.$store.dispatch("sendFileMsg", {
            scene: this.scene,
            to: this.to,
            type: "audio",
            blob: blob,
            ext: "mp3",
            orderTreatId: this.orderTreatId,
            uploadprogress: (obj) => {
              console.log("文件总大小111: " + obj.total + "bytes");
              console.log("已经上传的大小: " + obj.loaded + "bytes");
              console.log("上传进度: " + obj.percentage);
              console.log("上传进度文本: " + obj.percentageText);
              if (obj.percentage === 100) {
                this.$store.dispatch("hideLoading");
              }
            },
            uploaderror: () => {
              console && console.log("上传失败");
            },
            uploaddone: (error, file) => {
              console.log(error);
            },
          });
        });
        this.recorder.clear();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.m-chat-editor-main {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .mic {
    position: relative;
    .reacd-time {
      position: absolute;
      top: -24px;
      left: -3px;
      background: rgba(0, 0, 0, 0.5);
      padding: 3px 3px;
      border-radius: 5px;
    }
    .reacd-time::after {
      content: " ";
      position: absolute;
      /* top: 22px; */
      left: 50%;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      width: 0;
      height: 0;
      top: 100%;
      border-top: 5px solid rgba(0, 0, 0, 0.5);
    }
    img {
      width: 35px;
      height: 35px;
    }
  }
}
.Dia_contianer {
  text-align: center;
  .el-icon-question {
    font-size: 60px;
    margin-bottom: 10px;
  }
}
.u-editor-input {
  margin: 3px 10px;
  margin-bottom: 10px;
  width: 100%;
}
.u-editor-icon {
  position: relative;
  margin: 0 5px;
  img {
    width: 35px;
    height: 35px;
  }
}
.u-editor-send.u-editor-receipt {
  background-color: #fefefe;
  border: #ccc solid 1px;
  color: black;
  padding: 0.1rem;
  margin-left: 0.1rem;
}
.btn_mt {
  margin-bottom: 10px;
  text-align: left;
}
.btn_warp .u-editor-icon input[type="file"] {
  position: absolute;
  display: inline-block;
  left: 0;
  top: 0;
  height: 40px;
  opacity: 0;
  font-size: 0;
  width: 78px;
}

// 常用语
.common-warp {
  /deep/ .el-divider--horizontal {
    margin: 10px 0;
  }
  .common-word {
    display: flex;
    justify-content: space-between;
    &__top-title {
      width: 80%;
      cursor: pointer;
    }
  }
}
.common-footer {
  display: flex;
  justify-content: space-around;
  &__warp {
    display: flex;
    cursor: pointer;
  }
}
.icon_fontSize {
  font-size: 20px;
  margin: 0 5px;
  cursor: pointer;
}
</style>
